"use client";
import { subscriberSaveAction } from "@/actions/subscriber";
import { Input } from "@/components/ui/input";
import { useTranslations } from "@/i18n/client";
import { PendingButton } from "@/ui/admin/pending-button";
import { useAction } from "next-safe-action/hooks";
import { useState } from "react";

export const NewsletterClient = (props: { domain: string }) => {
	const { domain } = props;

	const [email, setEmail] = useState("");
	const { execute, isPending, result } = useAction(subscriberSaveAction);
	const t = useTranslations("/newsletter");

	return (
		<form
			onSubmit={(e) => {
				e.preventDefault();
				execute({ email, domain, name: "" });
			}}
			className="flex w-full flex-col gap-2"
		>
			<div className="flex w-full flex-col gap-2 sm:flex-row sm:flex-wrap">
				<div className="flex-1 sm:max-w-md ">
					<Input
						type="email"
						placeholder={t("emailPlaceholder")}
						className="w-full h-12 px-4 border-gray-200 focus:ring-2 focus:ring-blue-500 bg-white"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						required
						disabled={isPending}
					/>
				</div>
				<PendingButton
					pending={isPending}
					type="submit"
					className="h-12 inline-flex items-center justify-center rounded-full px-6 font-medium transition-colors focus:outline-hidden focus:ring-1 focus:ring-(--theme-button-color) bg-[var(--theme-hero-section-cta-background-color,#222)] text-[var(--theme-hero-section-cta-color,#EEE)] hover:bg-[var(--theme-hero-section-cta-hover-background-color,#555)]"
				>
					{t("subscribe")}
				</PendingButton>
				<p className="text-sm text-muted-foreground flex-1 basis-full">
					{(result.data
						? t("emailAdded")
						: result.serverError
							? result.serverError
							: result.validationErrors?.email?._errors?.[0]) || " "}
				</p>
			</div>
		</form>
	);
};
